module.exports = __webpack_public_path__ + "static/media/knee-swelling-copy.dcc38776.svg";